module.exports = __webpack_public_path__ + "static/media/Postales-05.e4a77504.png";